module.exports = __webpack_public_path__ + "img/lovebaby-icon.3376702f.png";